import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Shield } from "lucide-react";
import { motion } from "framer-motion";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@example.com");
  const [password, setPassword] = useState("adminpass");

  const handleLogin = (e) => {
    e.preventDefault();
    console.log('Admin login attempt');
    console.log('Simulating successful admin authentication');
    console.log('Zustand store updated with admin authentication state');
    navigate('/admin-dashboard');
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-background to-muted flex items-center">
      <div className="max-w-md mx-auto px-4 w-full">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="bg-card rounded-xl shadow-lg p-8"
        >
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-primary rounded-lg flex items-center justify-center mx-auto mb-4">
              <Shield className="text-primary-foreground text-2xl" />
            </div>
            <h1 className="text-2xl font-bold text-foreground mb-2">Admin Portal</h1>
            <p className="text-muted-foreground">Manage uploaded videos and user assignments</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-foreground mb-1">Email</label>
                <input 
                  type="email" 
                  className="form-input" 
                  placeholder="admin@example.com" 
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-foreground mb-1">Password</label>
                <input 
                  type="password" 
                  className="form-input" 
                  placeholder="adminpass" 
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="btn-primary w-full">
                Sign In
              </button>
            </div>
          </form>
        </motion.div>
      </div>
    </div>
  );
} 